import angular from 'angular';

angular.module('ll').filter('ContentLocation', ContentLocationFilter);

function ContentLocationFilter(SessionService, $translate) {
  return function (location) {
    let user = SessionService.getUser();
    switch (location) {
      case 'property':
        return user.isPropertyMember() ? user.property.name : '';
      case 'neighborhood':
        return user.neighborhood.name;
      case 'nearby_neighborhoods':
        return $translate.instant('MENU.SURROUNDINGS', {neighborhood: user.neighborhood.name});
      default:
        return '';
    }
  };
}
